export default "__VITE_ASSET__q4YVS8vz__"